import React, { useCallback, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, MessageCircleIcon } from 'lucide-react';
import { whatsappChats } from '../data/whatsappChats';
import { WhatsAppChat } from './WhatsAppChat';
export function WhatsAppTestimonials() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollToIndex = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(whatsappChats.length - 1, index));
    const item = track.children[clamped] as HTMLElement | undefined;
    if (!item) return;
    track.scrollTo({
      left: item.offsetLeft - track.offsetLeft,
      behavior: 'smooth'
    });
    setActiveIndex(clamped);
  }, []);
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    const items = Array.from(track.children) as HTMLElement[];
    const center = track.scrollLeft + track.clientWidth / 2;
    const closest = items.reduce((best, item, index) => {
      const itemCenter = item.offsetLeft - track.offsetLeft + item.clientWidth / 2;
      const distance = Math.abs(itemCenter - center);
      return distance < best.distance ? {
        index,
        distance
      } : best;
    }, {
      index: 0,
      distance: Number.POSITIVE_INFINITY
    });
    setActiveIndex(closest.index);
  };
  return <section aria-labelledby="chats" className="border-y border-ink-600 bg-ink-800" data-id="element-220" data-mp="9ljudo0v7aop">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-221" data-mp="9nwkwpkoutdd">
        <div className="flex flex-col items-center gap-6" data-id="element-222" data-mp="elfzjqlat85u">
          <div className="text-center" data-id="element-223" data-mp="jjzjjlgc09vk">
            <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.25em] text-[#25D366]" data-id="element-224" data-mp="jiyblpum43i2">
              <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-225" data-mp="nj8euur0sft8" />
              Mensajes reales
            </p>
            <h2 id="chats" className="mx-auto mt-4 max-w-2xl font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-226" data-mp="1z0hvl9irktqu">
              Otros coachs que ya lo están aplicando
            </h2>
          </div>

          <div className="flex gap-2" data-id="element-227" data-mp="3r1j7npg33lab">
            <button type="button" onClick={() => scrollToIndex(activeIndex - 1)} disabled={activeIndex === 0} aria-label="Ver conversación anterior" className="flex h-11 w-11 items-center justify-center rounded-md border border-ink-500 bg-ink-900 text-slate-300 transition-colors duration-150 ease-out hover:border-ball-400/60 hover:text-ball-400 disabled:opacity-40 disabled:hover:border-ink-500 disabled:hover:text-slate-300" data-id="element-228" data-mp="8wg3q81utfbh">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-229" data-mp="3hbpz6xb8nmaa" />
            </button>
            <button type="button" onClick={() => scrollToIndex(activeIndex + 1)} disabled={activeIndex === whatsappChats.length - 1} aria-label="Ver conversación siguiente" className="flex h-11 w-11 items-center justify-center rounded-md border border-ink-500 bg-ink-900 text-slate-300 transition-colors duration-150 ease-out hover:border-ball-400/60 hover:text-ball-400 disabled:opacity-40 disabled:hover:border-ink-500 disabled:hover:text-slate-300" data-id="element-230" data-mp="2tmdtw8j17yd9">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-231" data-mp="104pxrda7f1m3" />
            </button>
          </div>
        </div>

        <ul ref={trackRef} onScroll={handleScroll} className="scroll-shadow -mx-5 mt-10 flex snap-x snap-mandatory gap-5 overflow-x-auto px-5 pb-4 lg:justify-center" data-id="element-232" data-mp="1nuafxtyj9uub">
          {whatsappChats.map(chat => <li key={chat.name} className="w-[85%] shrink-0 snap-center sm:w-[400px] lg:w-[calc((100%-2.5rem)/3)]" data-id="element-233" data-mp="1itwi14qnc1a0">
              <WhatsAppChat chat={chat} data-id="element-234" data-mp="2i93kgwrp44k" />
            </li>)}
        </ul>

        <div className="mt-4 flex justify-center gap-2 lg:hidden" data-id="element-235" data-mp="7gkcmpf8nalq">
          {whatsappChats.map((chat, index) => <button key={chat.name} type="button" onClick={() => scrollToIndex(index)} aria-label={`Ver la conversación con ${chat.name}`} aria-current={activeIndex === index} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-out ${activeIndex === index ? 'w-6 bg-ball-400' : 'w-2 bg-ink-500'}`} data-id="element-236" data-mp="mr0g1e850kqe" data-mpi={index} />)}
        </div>

        <p className="mx-auto mt-6 max-w-xl text-center text-xs text-slate-500" data-id="element-237" data-mp="11my92nmrl8ye">
          Conversaciones compartidas por coaches del programa con su permiso. Nombres reales,
          capturas reproducidas para proteger sus números.
        </p>
      </div>
    </section>;
}